module.exports = __webpack_public_path__ + "assets/images/rbyearend-13-desktop.jpg?v=5ef53ac7";